import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Checkbox, Col, Divider, Form, Input, Row, Select } from "antd";

import {
  campoNumerico,
  maximoCaracteres,
  required,
} from "../../services/forms";
import { modalError, modalSuccess } from "../../services/notifications";
import { actions, hasPermission } from "../../services/security";
import { BASEURL } from "../../services/url";
import http from "../../services/http";
import "./Diccionario-form.css";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

const DiccionarioForm = (props) => {
  let navigate = useNavigate();
  const [form] = Form.useForm();
  const { id } = props;
  const Option = Select.Option;

  const [tipoCampo, setTipoCampo] = useState([]);
  const [tipoEntrada, setTipoEntrada] = useState([]);
  const [tipoEntradaFilter, setTipoEntradaFilter] = useState([]);
  const [formatoEntrada, setFormatoEntrada] = useState([]);
  const [formatoEntradaFilter, setFormatoEntradaFilter] = useState([]);

  const [loading, setLoading] = useState(false);
  const [inputsVisible, setInputsVisible] = useState(false);
  const [optionVisible, setOptionVisible] = useState(false);
  const [columnaTablaVisible, setColumnaTablaVisible] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);

  const disabled =
    id === "nuevo"
      ? !hasPermission(actions.DiccionarioCrear)
      : !hasPermission(actions.DiccionarioEditar);

  useEffect(() => {
    async function getForm() {
      let response = await http.get(`${BASEURL}/Parametry/Enums`);

      if (response) {
        const data = response.data;
        setTipoCampo(data.tiposCampo);
        setTipoEntrada(data.tiposEntrada);
        setFormatoEntrada(data.formatosEntrada);
      }

      if (id === "nuevo") {
        return;
      }

      response = await http
        .get(`${BASEURL}/Diccionario/${id}`)
        .catch((error) => {
          if (error.response) {
            modalError(error.response.data.errores[0].titulo);
          }
        });
      if (response) {
        const data = response.data;

        // let codigoBancoActual = localStorage.getItem("banco")

        // if (codigoBancoActual === "COR") {
        //   setDisabled(false);
        // }

        // else if (codigoBancoActual !== "COR" && codigoBancoActual === data.codBanco) {
        //   setDisabled(false)
        // }
        // else {
        //   if (data.codBanco !== "COR" || codigoBancoActual !== "COR") {
        //     if (!hasPermission(actions.DiccionarioCrear)) {
        //       setDisabled(false)
        //     }
        //     else if (!hasPermission(actions.DiccionarioEditar)) {
        //       setDisabled(false)
        //     }
        //     else {
        //       setDisabled(true)
        //     }
        //   }
        // }
        onChangeTipoCampo(data.tipoDeCampo.id);
        onChangeTipoEntrada(data.tipoDeEntrada.id);

        if (data.codBanco !== "COR") {
          form.setFieldsValue({ check: true });
        }

        form.setFieldsValue(data);
        form.setFieldsValue({
          opciones: data.opciones.map((item) => {
            return { opcion: item };
          }),
        });
        form.setFieldsValue({ tipoDeCampo: data.tipoDeCampo.id });
        form.setFieldsValue({ tipoDeEntrada: data.tipoDeEntrada.id });
        form.setFieldsValue({ formatoDeEntrada: data.formatoDeEntrada.id });
      }
    }

    getForm();
  }, [id, dataLoaded]);

  const onClickBack = () => {
    navigate("/diccionario");
  };

  const onClickSave = async (values) => {
    setLoading(true);

    if (values.opciones) {
      values.opciones = values.opciones.map((item) => {
        return {
          opcion: item.opcion,
        };
      });
    }

    let json = {
      nombre: values.nombre,
      codBanco: values.check ? localStorage.getItem("banco") : "COR",
      longitud: values.longitud,
      tipoDeCampo: values.tipoDeCampo,
      tipoDeEntrada: values.tipoDeEntrada,
      formatoDeEntrada: values.formatoDeEntrada,
      caracterDeRelleno: values.caracterDeRelleno,
      opciones: values.opciones ? values.opciones : [],
      descripcion: values.descripcion,
      textoPorDefecto: values.textoPorDefecto,
      cantidadFilas: values.cantidadFilas,
      definicionColumna: values.definicionColumna
        ? values.definicionColumna
        : [],
    };

    const response =
      id === "nuevo"
        ? await http.post(`${BASEURL}/Diccionario`, json).catch((error) => {
            if (error.response.status) {
              modalError(
                error.response.data.errores[0].titulo,
                error.response.data.errores[0].detalle
              );
            }
          })
        : await http
            .put(`${BASEURL}/Diccionario/${id}`, json)
            .catch((error) => {
              if (error.response.status) {
                modalError(
                  error.response.data.errores[0].titulo,
                  error.response.data.errores[0].detalle
                );
              }
            });

    setLoading(false);

    if (response) {
      await modalSuccess(
        "Diccionario guardado",
        id === "nuevo"
          ? "El diccionario fue creado exitosamente"
          : "El diccionario fue modificado exitosamente"
      );
      navigate("/diccionario");
    }
  };

  const onChangeTipoCampo = async (value) => {
    form.resetFields(["tipoDeEntrada", "formatoDeEntrada"]);
    setInputsVisible(false);
    setOptionVisible(false);
    setColumnaTablaVisible(false);

    switch (value) {
      case 1000:
        setTipoEntradaFilter(
          tipoEntrada
            .filter((item) => item.id !== 1005 && item.id !== 1004)
            .map((item) => {
              return item;
            })
        );
        setDataLoaded(true);
        setInputsVisible(true);
        break;

      case 1001:
        setTipoEntradaFilter(
          tipoEntrada
            .filter((item) => item.id === 1000)
            .map((item) => {
              return item;
            })
        );
        setFormatoEntradaFilter(
          formatoEntrada
            .filter((item) => item.id === 1007)
            .map((item) => {
              return item;
            })
        );
        setDataLoaded(true);
        onChangeTipoEntrada(1007);
        form.setFieldValue("tipoDeEntrada", 1000);
        form.setFieldValue("formatoDeEntrada", 1007);
        break;

      case 1002:
        setTipoEntradaFilter(
          tipoEntrada
            .filter((item) => item.id === 1000)
            .map((item) => {
              return item;
            })
        );
        setFormatoEntradaFilter(
          formatoEntrada
            .filter((item) => item.id === 1007)
            .map((item) => {
              return item;
            })
        );
        setDataLoaded(true);
        onChangeTipoEntrada(1007);
        form.setFieldValue("tipoDeEntrada", 1000);
        form.setFieldValue("formatoDeEntrada", 1007);
        setOptionVisible(true);
        break;

      case 1003:
        setTipoEntradaFilter(
          tipoEntrada
            .filter((item) => item.id === 1005)
            .map((item) => {
              return item;
            })
        );
        setFormatoEntradaFilter(
          formatoEntrada
            .filter((item) => item.id === 1007)
            .map((item) => {
              return item;
            })
        );
        setDataLoaded(true);
        setColumnaTablaVisible(true);
        onChangeTipoEntrada(1007);
        form.setFieldValue("tipoDeEntrada", 1005);
        form.setFieldValue("formatoDeEntrada", 1007);
        break;

      default:
        setTipoEntradaFilter([]);
        form.resetFields(["tipoDeEntrada"]);
        setFormatoEntradaFilter([]);
        form.resetFields(["formatoDeEntrada"]);
        setColumnaTablaVisible(false);
        setOptionVisible(false);
        setDataLoaded(true);
        break;
    }
  };

  const onChangeTipoEntrada = async (value) => {
    form.resetFields(["formatoDeEntrada"]);
    switch (value) {
      case 1000:
        setFormatoEntradaFilter(
          formatoEntrada
            .filter(
              (item) => item.id !== 1003 && item.id !== 1004 && item.id !== 1005
            )
            .map((item) => {
              return item;
            })
        );
        setDataLoaded(true);
        break;
      case 1001:
        setFormatoEntradaFilter(
          formatoEntrada
            .filter(
              (item) =>
                item.id !== 1000 &&
                item.id !== 1001 &&
                item.id !== 1002 &&
                item.id !== 1005
            )
            .map((item) => {
              return item;
            })
        );
        setDataLoaded(true);
        break;
      case 1002:
        setFormatoEntradaFilter(
          formatoEntrada
            .filter(
              (item) =>
                item.id !== 1000 &&
                item.id !== 1001 &&
                item.id !== 1002 &&
                item.id !== 1003 &&
                item.id !== 1004
            )
            .map((item) => {
              return item;
            })
        );
        setDataLoaded(true);
        break;

      case 1003:
        setFormatoEntradaFilter(
          formatoEntrada
            .filter(
              (item) =>
                item.id !== 1000 &&
                item.id !== 1001 &&
                item.id !== 1002 &&
                item.id !== 1003 &&
                item.id !== 1004
            )
            .map((item) => {
              return item;
            })
        );
        setDataLoaded(true);
        break;
      default:
        setDataLoaded(true);
        form.resetFields(["formatoDeEntrada"]);
    }
  };

  return (
    <Form layout="vertical" form={form} onFinish={onClickSave}>
      <Row gutter={16}>
        <div className="colums-inputs">
          <Col xs={24}>
            <Form.Item label="Nombre" name="nombre" rules={[required]}>
              <Input
                autoComplete="off"
                disabled={id === "nuevo" ? false : true}
              />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              label="Longitud"
              name="longitud"
              rules={[required, campoNumerico]}
            >
              <Input
                placeholder="Para longitud ilimitada, ingresar 0"
                autoComplete="off"
                disabled={id === "nuevo" ? false : true}
              />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              label="Tipo De Campo"
              name="tipoDeCampo"
              rules={[required]}
            >
              <Select
                disabled={!disabled && id !== "nuevo"}
                allowClear
                showSearch
                optionFilterProp="children"
                maxTagCount="responsive"
                onChange={onChangeTipoCampo}
              >
                {tipoCampo.map((option, index) => (
                  <Select.Option key={index} value={option.id}>
                    {option.nombre}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              label="Tipo De Entrada"
              name="tipoDeEntrada"
              rules={[required]}
            >
              <Select
                disabled={!disabled && id !== "nuevo"}
                allowClear
                showSearch
                optionFilterProp="children"
                onChange={onChangeTipoEntrada}
              >
                {tipoEntradaFilter.map((option, index) => (
                  <Select.Option key={index} value={option.id}>
                    {option.nombre}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              label="Formato De Entrada"
              name="formatoDeEntrada"
              rules={[required]}
            >
              <Select
                disabled={!disabled && id !== "nuevo"}
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {formatoEntradaFilter.map((option, index) => (
                  <Select.Option key={index} value={option.id}>
                    {option.nombre}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </div>

        <div className="colums-inputs">
          <Col xs={24}>
            <Form.Item label="Descripción" name="descripcion">
              <Input autoComplete="off" disabled={disabled} />
            </Form.Item>
          </Col>

          {columnaTablaVisible && (
            <Col xs={24}>
              <Form.Item
                label="Cantidad De Filas"
                name="cantidadFilas"
                rules={[required]}
              >
                <Input autoComplete="off" disabled={id !== "nuevo"} />
              </Form.Item>
            </Col>
          )}

          {inputsVisible && (
            <Col xs={24}>
              <Form.Item
                label="Carácter De Relleno"
                name="caracterDeRelleno"
                rules={[maximoCaracteres(5)]}
              >
                <Input autoComplete="off" disabled={disabled} />
              </Form.Item>
            </Col>
          )}

          {inputsVisible && (
            <Col xs={24}>
              <Form.Item label="Texto por defecto" name="textoPorDefecto">
                <Input autoComplete="off" disabled={disabled} />
              </Form.Item>
            </Col>
          )}
          <Col xs={24}>
            <Form.Item
              name="check"
              valuePropName="checked"
              style={{
                fontWeight: "bold",
              }}
            >
              <Checkbox disabled={id !== "nuevo" ? true : false}>
                Es local
              </Checkbox>
            </Form.Item>
          </Col>
        </div>
      </Row>

      <Divider
        style={{
          borderTop: "1px solid rgb(140 140 140 / 48%)",
        }}
      />

      {/* -- Columnas opciones -- */}
      <Row>
        {optionVisible && (
          <Col span={24}>
            <Form.List name="opciones">
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field, index) => (
                    <Row gutter={16} key={field.key}>
                      <Col span={8}>
                        <Form.Item
                          {...field}
                          label={"Opción"}
                          name={[field.name, "opcion"]}
                          fieldId={[field.key, "opcion"]}
                          rules={[required]}
                        >
                          <Input
                            autoComplete="off"
                            disabled={id === "nuevo" ? false : true}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item>
                          {!disabled && id === "nuevo" && (
                            <Button
                              type="danger"
                              onClick={() => remove(field.name)}
                              icon={<DeleteOutlined />}
                              style={{ marginTop: "20px" }}
                            />
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                  ))}
                  {!disabled && id === "nuevo" && (
                    <Col span={24}>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Agregar opción
                      </Button>
                    </Col>
                  )}
                </>
              )}
            </Form.List>
          </Col>
        )}
      </Row>
      {/* -- End columnas opciones */}

      <Row>
        {columnaTablaVisible && (
          <Col span={24}>
            <Form.List name="definicionColumna">
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field, index) => (
                    <Row gutter={16} key={field.key}>
                      <Col span={8}>
                        <Form.Item
                          {...field}
                          label={"Columna"}
                          name={[field.name, "nombreColumna"]}
                          fieldId={[field.key, "nombreColumna "]}
                        >
                          <Input disabled={id === "nuevo" ? false : true} />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item>
                          {!disabled && id === "nuevo" && (
                            <Button
                              type="danger"
                              onClick={() => remove(field.name)}
                              icon={<DeleteOutlined />}
                              style={{ marginTop: "20px" }}
                            />
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                  ))}
                  {!disabled && id === "nuevo" && (
                    <Col span={24}>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Agregar columna
                      </Button>
                    </Col>
                  )}
                </>
              )}
            </Form.List>
          </Col>
        )}
      </Row>

      <div className="actions">
        <Button type="text" onClick={onClickBack}>
          Volver
        </Button>
        {!disabled && (
          <Button type="primary" htmlType="submit" loading={loading}>
            {!loading && "Guardar"}
          </Button>
        )}
      </div>
    </Form>
  );
};

export default DiccionarioForm;
